import React, {useRef, useState} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import noImg from 'assets/img/pages/usr_noimg.png';
import CommonUtil from 'utils/CommonUtil';
import TbComFileMapngDetail from "domain/main/com/file/mapng/TbComFileMapngDetail";
import UI from "../../../../components/UI";

function ContentsContainer() {
	const history = useHistory();
	const [demandList, setDemandList] = useState<any[]>([]);
	const [totalCnt,setTotalCnt] = useState(0);
	const [searchDivCd, setSearchDivCd] = useState('0'); // 제목/내용 선택
	const [searchText, setSearchText] = useState('');
	const [searchOpt, setSearchOpt] = useState('');
	const [stsCd, setStsCd] = useState('');


	// 페이징 설정
	const [pageNum, setPageNum] = useState(1);      // 페이지 번호
	const [pageSize, setPageSize] = useState(20);    // 화면에 출력할 목록 갯수(10개)
	const pageCnt = useRef<any>(0);                 // 페이지 갯수

	const handleSelect = (e) => {
		if(e.target.name === 'searchDivCd') {
			setSearchDivCd(e.target.value);
		} else if(e.target.name === 'stsCd'){
			setStsCd(e.target.value);
		}
	};

	async function getRead() {

		let param = {
			"STS_CD": stsCd,
			"SEARCH_DIV_CD" : searchDivCd,
			"SEARCH_TEXT": searchText,
			"PAGE_NUM": pageNum,
			"PAGE_SIZE": pageSize
		}


		const response:any = await CommonUtil.execute({
			url: 'usr_1907',
			data: param
		}).then((response: any) => {

			setDemandList(response.REC);
			//전체ROW개수
			setTotalCnt(response.TOTAL);

			// 전체ROW개수
			setTotalCnt(response.TOTAL);
			// 페이징 갯수
			let totCnt = response.TOTAL;
			let rowCnt = pageSize;
			pageCnt.current = Math.floor((totCnt % rowCnt) == 0 ? totCnt / rowCnt : totCnt / rowCnt + 1);

		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});

	}


	async function pageMove(demandNo,seq) {
		let dataToSend = {DEMAND_NO : demandNo, SEQ : seq};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_1909',
			state: { data: dataToSend }
		});
	}

	React.useEffect(() => {
		getRead();
	},[pageNum])

	async function demandPage() {
		history.push({
			pathname: './usr_1904',
		});
	}

	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">상생협력기금안내</Link></li>
					<li><Link to="#">수요조사</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<h1 className="tx tx-hd2">수요조사</h1>
					<div className="fww-intro">
						<ul className="tab-menu">
							<li onClick={()=>demandPage()}><button type="button">수요조사</button></li>
							<li className={"active"}><button type="button">신청 내역</button></li>
						</ul>
						<div className={ 'tab-cont active'}>
							<div className="tb">
								<div className="tb-top">
									<div>
										<p className="tx fc-black">
											총 <em className="fw500 fc-pri">{totalCnt}</em>건의 게시물이 있습니다
											(<em className="fw500 fc-pri">{pageNum}/{pageCnt.current < 1 ? 1 : pageCnt.current}</em> 페이지)
										</p>
									</div>
								</div>
								<table>
									<caption>게시판 목록</caption>
									<colgroup>
										<col width="90px" />
										<col />
										<col width="120px" />
										<col width="120px" />
										<col width="140px" />
										<col width="120px" />
									</colgroup>
									<thead>
										<tr>
											<th scope="col">번호</th>
											<th scope="col">제목</th>
											<th scope="col">상태</th>
											<th scope="col">작성자</th>
											<th scope="col">등록일</th>
											<th scope="col">조회수</th>
										</tr>
									</thead>
									<tbody>
									{demandList != null ? (
										demandList.map((demand, index) => (
											index <= 19 &&
											<tr>
												<td>{demand.ROWNUM}</td>
												<td className="ta-left">
													<a href="#" onClick={(e) => {
														e.preventDefault();
														pageMove(demand.DEMAND_NO,demand.SEQ);
													}} className="tx tx-bd2 tx-link">{demand.REQ_TITLE}</a>
												</td>
												<td>{demand.REQ_CANCEL_YN == 'N' ? '지원완료' : '지원취소'}</td>
												<td>{demand.PERSON_NM}</td>
												<td>{demand.REQ_DATE}</td>
												<td>{demand.RET_CNT}</td>
											</tr>
										))
									) : (
										<tr>
											<td colSpan={6} className="text-center">
												게시물이 없습니다
											</td>
										</tr>
									)}
									</tbody>
								</table>
							</div>

							<UI.PaginationBar
								totalCnt={totalCnt}
								rowCnt={20}
								currentPage={pageNum}
								onChange={(current:number) => {
									setPageNum(current);
								}}
							/>

						</div>
					</div>
				</main>
			</div>			
		</PageContainer>
	);
}
export default ContentsContainer;